import {BrowserModule, Title} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import {AuthInterceptor} from './admin/auth/auth.interceptor';
import {AppRoutingModule} from './app-routing.module';
import {AdminModule} from './admin/admin.module';
import {BootstrapComponent} from './bootstrap.componnet';
import {FileUploadService} from './file-upload.service';
// import {CompanyModule} from './company/company.module';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {EffectsModule} from '@ngrx/effects';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {translateFactory} from './custom-translate-loader';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import * as Sentry from '@sentry/angular';
import {MAT_DATE_LOCALE, MAT_DATE_FORMATS} from '@angular/material/core';
import {APP_DATE_FORMATS, APP_DATE_LOCALE} from './shared/datetime-formats';

@NgModule({ declarations: [BootstrapComponent],
    bootstrap: [BootstrapComponent], imports: [InfiniteScrollModule,
        FontAwesomeModule,
        AdminModule,
        BrowserAnimationsModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: translateFactory,
                deps: [HttpClient],
            },
        }),
        StoreModule.forRoot({}),
        EffectsModule.forRoot([]),
        StoreDevtoolsModule.instrument({ connectInZone: true })], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
        { provide: MAT_DATE_LOCALE, useValue: APP_DATE_LOCALE },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
        FileUploadService,
        Title,
        provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({
            cookieName: 'csrftoken',
            headerName: 'X-CSRFToken',
        })),
    ] })
export class AppModule {}
